import api from './api';

// The assistant has two shapes, because two jobs with very different clocks share one endpoint.
//
// chat()      — inline. A header or footer comes back in a few seconds, inside the HTTP request.
// chatJob()   — a job. Reading an uploaded folio PDF and writing a whole document takes a minute or
//               more, and API Gateway abandons any request at ~29 seconds: the browser used to get a
//               504 while the answer was still being written, and then lost. The POST now returns a job
//               id immediately, the work continues on a second invocation, and this polls for it.
// WAIT FOR AN ASSISTANT JOB — shared by every assistant that runs as a job (/opt/utils/assistant-jobs on the server):
// the folio template assistant here and the billing template assistant (billingService). Polls every 2s; `timeoutMs`
// bounds the wait so a job that dies upstream ends as a message rather than a spinner. -> { data: { reply } }
export const waitForJob = async (jobId, getJob, { intervalMs = 2000, timeoutMs = 300000 } = {}) => {
  if (!jobId) throw new Error('The assistant did not start.');
  const deadline = Date.now() + timeoutMs;
  for (;;) {
    await new Promise(r => setTimeout(r, intervalMs));
    const job = (await getJob(jobId)) || {};
    if (job.status === 'done') return { data: { reply: job.reply } };
    if (job.status === 'error') throw new Error(job.error || 'The assistant request failed.');
    if (Date.now() > deadline) throw new Error('The assistant is taking longer than expected. Try again.');
  }
};

const templateAssistantService = {
  // messages: [{ role: 'user' | 'assistant', content }]
  // hotelContext: { availableFields: [...], currentHeader, currentFooter }
  chat: (messages, hotelContext) =>
    api.post('/admin/templateassistant', { messages, hotelContext }),

  startJob: (messages, hotelContext) =>
    api.post('/admin/templateassistant', { messages, hotelContext, async: true }),

  getJob: (jobId) => api.get(`/admin/templateassistant/${jobId}`),

  // Start the work and wait for it (waitForJob).
  chatJob: async (messages, hotelContext, opts) => {
    const started = await templateAssistantService.startJob(messages, hotelContext);
    return waitForJob(started.data?.jobId, (id) => templateAssistantService.getJob(id).then(r => r.data), opts);
  },
};

export default templateAssistantService;
